/**
 * @license
 * Copyright 2018-2021 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const STREAMLIT_HOME_URL = "https://streamlit.io"
export const DEPLOY_URL = "https://share.streamlit.io/deploy"
export const STREAMLIT_SHARE_URL = "https://streamlit.io/sharing"
export const ONLINE_DOCS_URL = "https://docs.streamlit.io"
export const COMMUNITY_URL = "https://discuss.streamlit.io"
export const TEAMS_URL = "https://streamlit.io/forteams"
export const BUG_URL =
  "https://github.com/streamlit/streamlit/issues/new/choose"

/** The URL we direct people to for troubleshooting components. */
export const COMPONENT_DEVELOPER_URL =
  "https://docs.streamlit.io/en/stable/develop_streamlit_components.html"
export const CLOUD_COMM_WHITELIST = [
  "devel.streamlit.test",
  "share.streamlit.io",
  "share-head.streamlit.io",
  "share-staging.streamlit.io",
]
